import React from 'react';
import { Item } from '@radix-ui/react-dropdown-menu';
import pt from 'prop-types';

import { classNames } from 'utils';

export default class DropdownMenuItem extends React.PureComponent {
  static propTypes = {
    children: pt.node.isRequired,
    className: pt.string,
  };

  render() {
    const { children, className } = this.props;

    return (
      <Item
        {...this.props}
        className={classNames('dropdown-menu-item', className)}
      >
        {children}
      </Item>
    );
  }
}
